"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const respinner_1 = require("respinner");
const lib_1 = require("../../lib");
const BeatLoader = respinner_1.BeatLoading;
const LoadingIndicator = (props) => {
    return ((0, jsx_runtime_1.jsx)(BeatLoader, { count: 4, size: 5, className: (0, lib_1.bem)("spinner__svg", "--beat") }, void 0));
};
exports.LoadingIndicator = LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map